import { Link } from "react-router-dom";

const friendLinks = [
  { label: "影视资讯", to: "/about" },
  { label: "播放说明", to: "/about" },
  { label: "意见反馈", to: "/about" },
  { label: "版权声明", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50 text-xl">
                <i className="ri-play-fill" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">蘑菇视频</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              蘑菇视频是面向广大影视爱好者的高清影视资源平台，汇集电影、电视剧、综艺等多元内容，提供影视资讯、编辑推荐与便捷的浏览筛选体验。
            </p>
            <p className="mt-4 text-xs text-secondary-400">
              本站内容为演示示例，不提供真实播放接口，所有影视信息仅供展示之用。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <h4 className="mb-4 text-sm font-semibold text-background-50">内容导航</h4>
              <ul className="space-y-2.5 text-sm">
                <li><Link to="/category/movie" className="text-background-300 hover:text-primary-300 cursor-pointer">电影</Link></li>
                <li><Link to="/category/tv" className="text-background-300 hover:text-primary-300 cursor-pointer">电视剧</Link></li>
                <li><Link to="/category/variety" className="text-background-300 hover:text-primary-300 cursor-pointer">综艺</Link></li>
                <li><Link to="/search" className="text-background-300 hover:text-primary-300 cursor-pointer">搜索</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="mb-4 text-sm font-semibold text-background-50">友情链接</h4>
              <ul className="space-y-2.5 text-sm">
                {friendLinks.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-background-300 hover:text-primary-300 cursor-pointer">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <h4 className="mb-4 text-sm font-semibold text-background-50">联系我们</h4>
              <ul className="space-y-2.5 text-sm text-background-300">
                <li className="flex items-center gap-2"><i className="ri-mail-line text-primary-300" aria-hidden="true"></i>hello@moguvideo.com</li>
                <li className="flex items-center gap-2"><i className="ri-wechat-line text-primary-300" aria-hidden="true"></i>蘑菇视频官方</li>
                <li className="flex items-center gap-2"><i className="ri-weibo-line text-primary-300" aria-hidden="true"></i>@蘑菇视频</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-secondary-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 蘑菇视频 MOGU VIDEO. 保留所有权利。本站为演示站点，内容仅供展示。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>隐私政策</span>
            <span>用户协议</span>
            <span>内容投诉</span>
          </p>
        </div>
      </div>
    </footer>
  );
}